export default __webpack_public_path__ + "static/media/ComingSoon.89b8e227.svg";